module.exports = __webpack_public_path__ + "static/prize-01-a4112c8478f9411182c5f07f8fe44849.png";